import Backbone from 'backbone'
import _ from 'lodash'

const LineClamp = Backbone.View.extend({

	initialize: function(options) {
		this.options = options || {}
		this._setupListeners()
	},

	_setupListeners: function() {
		this.$('.toggle-expand').on('click', e => {
			this.toggleExpanded()
			e.preventDefault()
			e.stopPropagation()
		})
	},

	toggleExpanded: function(expanded) {
		this.$el.toggleClass('is-expanded', expanded)
		this.trigger('toggleExpanded')
	},

	resize: function() {
		// If we've already intentionally expanded the element, exit here because there's
		// no need calculating then to see if there's overflow
		if (this.isExpanded()) {
			return
		}

		this.$el.removeClass('needs-clamping')

		// If the difference between the scrollHeight and maxHeight is less than 3px,
		// lets not activate .needs-clamping; that's not enough to warrant the
		// expanding/colllapsing.
		if (Math.abs(this.el.scrollHeight - this.options.maxHeight) > 3) {
			// If there's a significant difference between the scroll and min heights,
			// and if the scrollHeight is more than the max height
			let isOverflowing = this.el.scrollHeight > this.options.maxHeight
			this.$el.toggleClass('needs-clamping', isOverflowing)
		}
	},

	isExpanded: function() {
		return this.$el.hasClass('is-expanded')
	}
})

export default LineClamp

LineClamp.__filename__ = 'components/line-clamp.js'
